import { Logger } from '@ori/logger';
import { PACKAGE_NAME, TEAM_NAME } from './constants-generated';
export const mainLogger = new Logger(PACKAGE_NAME, {
    teamName: TEAM_NAME
});
export const mypagesMainLogger = new Logger(PACKAGE_NAME, {
    part: 'mypages',
    teamName: TEAM_NAME
});
export const campaignsMainLogger = new Logger(PACKAGE_NAME, {
    part: 'campaigns',
    teamName: TEAM_NAME
});
export const landingMainLogger = new Logger(PACKAGE_NAME, {
    part: 'landing',
    teamName: TEAM_NAME
});
export const whatsNewLandingMainLogger = new Logger(PACKAGE_NAME, {
    part: 'whats-new-landing',
    teamName: TEAM_NAME
});
export const whatsNewMainLogger = new Logger(PACKAGE_NAME, {
    part: 'whats-new',
    teamName: TEAM_NAME
});
export const goToLandingMainLogger = new Logger(PACKAGE_NAME, {
    part: 'go-to-landing',
    teamName: TEAM_NAME
});
export const goToPageMainLogger = new Logger(PACKAGE_NAME, {
    part: 'go-to-page',
    teamName: TEAM_NAME
});
export const aboutUsLandingMainLogger = new Logger(PACKAGE_NAME, {
    part: 'about-us-landing',
    teamName: TEAM_NAME
});
export const aboutUsPageMainLogger = new Logger(PACKAGE_NAME, {
    part: 'about-us-page',
    teamName: TEAM_NAME
});
